import type { FaqItem } from '../types/faq';

export const homeFaq: FaqItem[] = [
  {
    question: 'Wat is de beste online slot in Nieuw-Zeeland?',
    answer:
      'Volgens de SlotGids Score is Gates of Olympus van Pragmatic Play op dit moment de beste online slot in Nieuw-Zeeland, gevolgd door Book of Dead (Play’n GO) en Sweet Bonanza (Pragmatic Play). De score combineert populariteit in Nieuw-Zeeland en bij Nederlandstalige spelers met gameplay, RTP en mobiele ervaring.',
  },
  {
    question: 'Wat zijn pokies?',
    answer:
      'Pokies is het Nieuw-Zeelandse en Australische woord voor gokkasten. Online pokies en online slots betekenen dus hetzelfde: digitale gokkasten met rollen, winlijnen en bonusfeatures.',
  },
  {
    question: 'Zijn online slots legaal in Nieuw-Zeeland?',
    answer:
      'Nieuw-Zeeland voert met de Online Casino Gambling Act 2026 een vergunningsstelsel in voor online casino’s. Vanaf 1 december 2026 mogen alleen operators die een Nieuw-Zeelandse vergunning hebben aangevraagd spelers in Nieuw-Zeeland bedienen; het volledige vergunningsstelsel wordt in 2027 verwacht. Controleer daarom altijd de vergunning van een casino.',
  },
  {
    question: 'Kan ik de slots uit de Top 30 gratis spelen?',
    answer:
      'Ja. Bij elke slot in de Top 30 vind je een demoknop. In de demo speel je met speelgeld, zonder account en zonder storting, zodat je de mechaniek en volatiliteit eerst kunt leren kennen.',
  },
  {
    question: 'Wat betekent RTP bij een slot?',
    answer:
      'RTP (Return to Player) is het percentage van alle inzetten dat een slot op de lange termijn uitbetaalt. Een RTP van 96,5% betekent dat er gemiddeld NZ$96,50 per NZ$100 inzet wordt teruggegeven, berekend over miljoenen spins. Casino’s kunnen een lagere RTP-versie aanbieden.',
  },
  {
    question: 'Hoe stelt SlotGids de Top 30 samen?',
    answer:
      'Elke slot krijgt een SlotGids Score van 0 tot 10, gebaseerd op populariteit in Nieuw-Zeeland (30%), populariteit bij Nederlandstalige spelers (25%), gameplay (15%), RTP (10%), mobiele ervaring (10%), levensduur (5%) en originaliteit (5%). Casino’s kunnen geen positie kopen.',
  },
];
